$(document).on('ajax:before', 'form#multiple_users_confirmation', function(event) {
  if ($('input[name="selected_user"]:checked').length === 0) {
    return false; // This stops Rails UJS from posting the form if no user is selected
  }
});

$(document).on('ajax:success', 'form#multiple_users_confirmation', function(event) {
  $('#multiple_users_confirmation_modal').modal('hide');
});
